import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

const LABELS = { loading_area: "loading area", offloading_area: "offloading area" };

export default function AreaSuggestions({ filters, loads, onPick }) {
  const [sugg, setSugg] = useState({});
  const needs = loads && (loads.length === 0 || loads.some((l) => l.area_match === "close"));

  useEffect(() => {
    if (!needs) return setSugg({});
    const keys = Object.keys(LABELS).filter((k) => filters[k].trim());
    Promise.all(keys.map((k) => api.get("/loads/suggest", { params: { q: filters[k] } }).then((r) => [k, r.data.suggestions]).catch(() => [k, []])))
      .then((pairs) => setSugg(Object.fromEntries(pairs.filter(([, v]) => v.length))));
  }, [needs, filters]);

  const close = loads?.filter((l) => l.area_match === "close").length || 0;
  if (!close && !Object.keys(sugg).length) return null;

  return (
    <div className="hf-card p-4 border-amber-200 bg-amber-50/60 text-sm space-y-2" data-testid="area-suggestions">
      {close > 0 && (
        <p className="flex items-center gap-2 text-amber-900" data-testid="close-match-notice">
          <Sparkles className="w-4 h-4" /> {t("Including {n} close match(es) — similar spellings, abbreviations (e.g. KZN, FS) and provinces.", { n: close })}
        </p>
      )}
      {Object.entries(sugg).map(([k, list]) => (
        <p key={k} className="flex flex-wrap items-center gap-2">
          <span className="text-slate-600">{t("Did you mean")} ({t(LABELS[k])}):</span>
          {list.map((s) => (
            <button key={s} onClick={() => onPick(k, s)} className="h-7 px-3 rounded-full bg-white border border-amber-300 text-amber-800 text-xs font-semibold hover:bg-amber-100" data-testid={`suggestion-${k}-${s.replace(/\s/g, "-")}`}>{s}</button>
          ))}
        </p>
      ))}
    </div>
  );
}
